var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleTable',{ref:"table",attrs:{"columns":_vm.columnDefinition,"data":_vm.rows,"highlight":_vm.selected},on:{"click":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }